module.exports = __webpack_public_path__ + "static/zenva_responsive_web_design-ba10e7b7f4485065646ce37ad91aaa3a.pdf";